import { z } from 'zod';
import { CoSellMsftCreateFormDataId as DataId } from '../constants';
import { SolutionInput } from '../referralFormSchema';

export enum FieldEnum {
  solutions = 'details.requirements.solutions',
}

export enum SolutionFieldEnum {
  type = 'type',
  id = 'id',
  name = 'name',
  publisherName = 'publisherName',
  price = 'price',
  quantity = 'quantity',
  currency = 'currency',
  solutionType = 'solutionType',
}

export const SolutionFieldMap = {
  [SolutionFieldEnum.price]: {
    label: 'Price per unit',
    dataId: `${DataId.FIELD_PREFIX}-solutions-price`,
    required: true,
    type: 'number',
  },
  [SolutionFieldEnum.quantity]: {
    label: 'Quantity',
    dataId: `${DataId.FIELD_PREFIX}-solutions-quantity`,
    required: true,
    type: 'number',
  },
  [SolutionFieldEnum.currency]: {
    label: 'Currency',
    dataId: `${DataId.FIELD_PREFIX}-solutions-currency`,
    required: true,
    type: 'single-select',
  },
};

export type SolutionInputType = z.input<typeof SolutionInput>;
